// The numbers the render screens are NOT allowed to invent.
//
// Each of these lived in TypeScript as a literal until now, and each literal was
// a quiet promise the server had not agreed to:
//
//   gemsPerEdit         the generator priced an edit at 1 gem while the landing
//                       page sold it at 3. P01 owns the price and it has already
//                       moved once.
//   maxBatch            the stepper stopped at 10; the API has accepted 100 all
//                       along, so the product hid nine tenths of what it can do.
//   maxEditDurationSec  deployment config, not a constant — a box configured
//                       under 30 would 400 the trim its own slider offered.
//
// There is deliberately NO default for the price. A screen that cannot reach the
// server does not know what an edit costs, and printing a plausible number is the
// exact failure this module exists to stop. Callers render a dash until it lands.

import { api } from './api'

export interface RenderConfig {
  gemsPerEdit: number
  maxBatch: number
  maxEditDurationSec: number
  /** 0017 (onboarding): what a post and a cut cost, and the upload limits — the numbers
   *  the first-run copy prints. Optional: an older server answers without them and the
   *  screen then says it does not know, rather than printing a constant. */
  publishGems?: number
  cutGems?: number
  musicMaxBytes?: number
  musicAllowedExt?: string[]
  maxMusicDurationSec?: number
  maxPendingAnalysis?: number
}

interface ConfigBody {
  gems_per_edit: number
  max_batch: number
  max_edit_duration_sec: number
  publish_gems?: number
  cut_gems?: number
  music_max_bytes?: number
  music_allowed_ext?: string[]
  max_music_duration_sec?: number
  max_pending_analysis?: number
}

export async function fetchRenderConfig(signal?: AbortSignal): Promise<RenderConfig> {
  const body = await api<ConfigBody>('/api/render/config', { signal })
  return {
    gemsPerEdit: body.gems_per_edit,
    maxBatch: body.max_batch,
    maxEditDurationSec: body.max_edit_duration_sec,
    publishGems: body.publish_gems,
    cutGems: body.cut_gems,
    musicMaxBytes: body.music_max_bytes,
    musicAllowedExt: body.music_allowed_ext,
    maxMusicDurationSec: body.max_music_duration_sec,
    maxPendingAnalysis: body.max_pending_analysis,
  }
}
